import { faker } from '@faker-js/faker/locale/es';
import type { Machine } from './types';

export interface AlertRow {
  id: string;
  severity: 'CRITICAL' | 'WARNING' | 'INFO';
  message: string;
  source: string;
  timestamp: string;
  acknowledged: boolean;
}

const SEVERITY_MIX: Array<{ value: AlertRow['severity']; weight: number }> = [
  { value: 'CRITICAL', weight: 0.10 },
  { value: 'WARNING', weight: 0.40 },
  { value: 'INFO', weight: 0.50 },
];

const MESSAGE_TEMPLATES = [
  'Vibración elevada en {id}',
  'Temperatura sobre umbral en {id}',
  'Consumo energético anómalo en {id}',
  'Ciclo fuera de rango en {id}',
  'Sensor de flujo desconectado en {id}',
  'Lubricación necesaria en {id}',
  'Desviación calibración en {id}',
  'Tiempo de cambio elevado en {id}',
];

export function generateAlerts(machines: Machine[], count: number = 30): AlertRow[] {
  const alerts: AlertRow[] = [];
  for (let i = 0; i < count; i++) {
    const machine = faker.helpers.arrayElement(machines);
    const tpl = faker.helpers.arrayElement(MESSAGE_TEMPLATES);
    const ts = faker.date.recent({ days: 2 }).toISOString();
    alerts.push({
      id: `ALT-${String(1000 + i)}`,
      severity: faker.helpers.weightedArrayElement(SEVERITY_MIX),
      message: tpl.replace('{id}', machine.id),
      source: machine.id,
      timestamp: ts,
      acknowledged: faker.datatype.boolean({ probability: 0.6 }),
    });
  }
  return alerts.sort((a, b) => +new Date(b.timestamp) - +new Date(a.timestamp));
}
